"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../baseSchema");
const baseTrySchema_1 = require("../baseSchema/baseTrySchema");
class TryUploadSubtitlesSchema extends baseTrySchema_1.BaseTrySchema {
    constructor({ result, statusCode, failureDescription }) {
        super({
            result,
            statusCode,
            failureDescription,
            componentName: 'UPLOAD_SUBTITLES_BUTTON',
            componentSource: 'UPLOAD_SUBTITLES_BUTTON'
        });
        this.action = baseSchema_1.ActionsName.TRY_UPLOAD_SUBTITLES;
    }
    getDataHubEventData() {
        return {
            ...super.prepare()
        };
    }
}
exports.default = TryUploadSubtitlesSchema;
